import React, { useState } from "react";

//carousel
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
//firebase
import { bannerCollection } from "../../../../components/firebase/DataProvider";
//style
import useStyles from "./style/style";
import { useDocumentDataOnce } from "react-firebase-hooks/firestore";
import { Skeleton } from "@material-ui/lab";

function Banner() {
  const classes = useStyles();
  const bannerRef = bannerCollection.doc('banner-satu');
  const [ban, setBan] = useState()
  const [banner] = useDocumentDataOnce(bannerRef)

  // sceleton manual
  setTimeout(() => {
    setBan(banner)
  }, 1000);

  return (
    <div className={classes.wrapCarousel}>
      <Carousel className={classes.carousel} showIndicators={false} showArrows={false} showThumbs={false} emulateTouch={true} infiniteLoop={true} showStatus={false}  >
        <div>
        {ban ? (
          <img className={classes.hero} src={banner?.url} alt="banner" />
        ) : (
          <Skeleton variant="rect" className={classes.hero} />
        )}
        </div>
      </Carousel>
    </div>
  );
}

// className={classes.hero} className={classes.carousel}

export default React.memo(Banner);
